import { EmbedInterface, GroupInterface } from '@swivl-mono/types';
import { APIService } from '../Service/API.Service';

export class EmbedsAPI {
  static async getEmbeds(orgId: number) {
    return APIService.Server.get<EmbedInterface[]>(
      `/embeds/org/${orgId}`
    );
  }
  static async getEmbed(orgId: number, embedId: number) {
    return APIService.Server.get<EmbedInterface>(
      `/embeds/org/${orgId}/embed/${embedId}`
    );
  }
  static async createEmbed(orgId: number, embed: Partial<EmbedInterface>) {
    return APIService.Server.post<EmbedInterface>(
      `/embeds/org/${orgId}/embed`,
      embed
    );
  }
  static async updateEmbed(orgId: number, embed: EmbedInterface) {
    return APIService.Server.put<EmbedInterface>(
      `/embeds/org/${orgId}/embed/${embed.id}`,
      embed
    );
  }
  static async deleteEmbed(orgId: number, embedId: number) {
    return APIService.Server.delete(
      `/embeds/org/${orgId}/embed/${embedId}`
    );
  }
}
